import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <Navbar />
      <div className="relative flex flex-col items-center justify-center min-h-[80vh] text-center px-4 pt-24 pb-20 bg-background-50">
        <h2 className="text-8xl md:text-[10rem] font-heading font-bold text-foreground-100 select-none pointer-events-none">
          404
        </h2>
        <div className="relative z-10 -mt-8">
          <h1 className="text-xl md:text-2xl font-heading font-semibold text-foreground-950 mt-4 mb-2">
            页面未找到
          </h1>
          <p className="text-sm text-foreground-500 font-mono mb-1">{location.pathname}</p>
          <p className="text-sm text-foreground-600 mb-8">
            你访问的页面不存在或已被移除
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 px-6 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line text-sm"></i>
            返回首页
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
}